<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import Expander from "@/app/utils/expander.js";
    @Component({
        components: {},
    })
    export default class ChartDarkDropdown extends Vue {
        @Prop()
        data;
        @Prop()
        defaultIndex;

        showOption = false;
        activeIndex = 0;

        expander = null;
        expandFunc(type: string, args?: any) {
            if (!this.expander) {
                let dom = this.$refs.dropdownRoot;
                let expand = () => {
                    this.showOption = !this.showOption;
                };
                let select = (args: any) => {
                    // 点击内容区冒泡触发隐藏窗口
                    let { index, item } = args;
                    this.showOption = false;
                    this.activeIndex = index;
                    this.$emit("selectData", index);
                };
                let close = () => {
                    this.showOption = false;
                };
                this.expander = new Expander(dom, {
                    expand: expand,
                    select: select,
                    close: close,
                });
            }
            if (type == "expand") {
                this.expander.expand();
            } else if (type == "select") {
                this.expander.select(args);
            }
        }
        setActiveIndex(index: number) {
            this.activeIndex = index;
        }

        get title() {
            return this.data[this.activeIndex]?.label || "";
        }
    }
</script>

<template>
    <div ref="dropdownRoot" class="z-dropdown">
        <div class="z-dropdown-titlebox" @click="expandFunc('expand')">
            <p class="z-dropdown-title">
                {{ title }}
            </p>
            <iconSymbol class="z-dropdown-arrow" name="dropdown-arrow" />
        </div>
        <div class="z-dropdown-selector" v-show="showOption">
            <div
                class="z-dropdown-item"
                :class="{ active: activeIndex == index }"
                v-for="(item, index) in data"
                :key="index"
                @click="expandFunc('select', { index, item })"
            >
                <iconSymbol v-show="activeIndex == index" class="z-dropdown-itemicon" name="dropdown-checked" />
                <p class="z-dropdown-itemtext">{{ item.label }}</p>
            </div>
        </div>
    </div>
</template>

<style lang="stylus" scoped>
    .z-dropdown
        position relative
        height 20px
        width 100%
        padding 2px 4px
        border-radius 4px
        background rgba(255, 255, 255, 0.2)
        user-select none

        .z-dropdown-titlebox
            display flex
            align-items center
            width 100%

            .z-dropdown-title
                color #fff
                font-size 12px
                line-height 16px
                width calc(100% - 8px)
                overflow hidden
                text-overflow ellipsis
                white-space nowrap

            .z-dropdown-arrow
                width 8px
                height 8px
                pointer-events none
        .z-dropdown-selector
            position absolute
            top 24px
            left 0
            min-width 100%
            padding 6px
            background #474748
            box-shadow 0px 0px 4px rgba(0, 0, 0, 0.05), 0px 2px 10px rgba(0, 0, 0, 0.08)
            border-radius 8px
            z-index 2

            .z-dropdown-item
                position relative
                display flex
                align-items center
                height 28px
                border-radius 6px

                &:hover
                    background rgba(255, 255, 255, 0.06)
                &.active
                    background rgba(255, 255, 255, 0.08)

                .z-dropdown-itemicon
                    position absolute
                    left 4px
                    top 6px
                    width 16px
                    height 16px
                    color #DADADF

                .z-dropdown-itemtext
                    padding-left 26px
                    font-size 12px
                    color #fff
                    max-width 120px
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
</style>
